module.exports = __webpack_public_path__ + "static/media/ourofino.7322c267.svg";